import { render, staticRenderFns } from "./CasosTot.vue?vue&type=template&id=4c55fd11"
import script from "./CasosTot.vue?vue&type=script&lang=js"
export * from "./CasosTot.vue?vue&type=script&lang=js"
import style0 from "./CasosTot.vue?vue&type=style&index=0&id=4c55fd11&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports